import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Slider';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "slider"
    }}>{`Slider`}</h1>
    <p>{`Accessible and themeable form range input component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Label, Slider } from '@rebass/forms'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box>
  <Label htmlFor='percent'>Percent</Label>
  <Slider
    id='percent'
    name='percent'
    defaultValue={25}
  />
</Box>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      